import Logo from "../../../assets/images/logo.svg";
import { Link } from "react-router-dom";
const EmailSentPage = () => {
  return (
    <div className="mt-32 center">
      <Link to="/login">
        <img className="mb-16 height-10" src={Logo} alt="Logo" />
      </Link>
      <div className="width-500px height-600px py-8 px-16 card center">
        <h2>Password Reset Email Sent</h2>
        <p>
          An email has been sent. Please click the link in the email to confirm
          your email address.
        </p>
      </div>
    </div>
  );
};

export default EmailSentPage;
